import { createFileRoute } from '@tanstack/react-router';

import { SupplierDirectoryPage } from '@/features/marketplace/supplier-directory-page';

export const Route = createFileRoute('/_app/marketplace/suppliers/')({
  component: SupplierDirectoryPage,
});
